import { apiClient } from './apiClient';
import { CreateProposalPayload, Deal, Proposal } from '../types';

export const proposalService = {
  async create(payload: CreateProposalPayload): Promise<Proposal> {
    const { data } = await apiClient.post<Proposal>('/proposals/', payload);
    return data;
  },

  async accept(proposalId: string): Promise<Deal> {
    const { data } = await apiClient.post<Deal>(`/proposals/${proposalId}/accept/`);
    return data;
  },

  async reject(proposalId: string, reason?: string): Promise<Proposal> {
    const { data } = await apiClient.post<Proposal>(`/proposals/${proposalId}/reject/`, { reason });
    return data;
  },
};
